module.exports = __webpack_public_path__ + "assets/kosher-ce91bb.svg";